
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.713 15.708c-.388.39-1.038.39-1.427 0L.296 6.724a1.01 1.01 0 011.426-1.427L10 13.567l8.277-8.271a1.01 1.01 0 111.428 1.427z","fill":"#323232"}})])
          )
        }
      }
    